'use client'
import React from 'react'
import Image from 'next/image'

import { useTranslations } from '@/lib/i18nProvider'
import { doSignInWithApple, doSignInWithGoogle2 } from '@/model/firebase/auth'

import { clc } from '../base/utils'

import styles from './SocialBtn.module.scss'

type Props = {
	authType: 'login' | 'signup'
	social: 'Apple' | 'Google'
}

const onClick = async (type: Props['social'], callback: Props['authType']) => {
	if (type === 'Google') {
		// doSignInWithGoogle(callback)
		doSignInWithGoogle2(callback)
	}

	if (type === 'Apple') {
		doSignInWithApple(callback)
	}
}
const SocialBtn = ({ authType, social }: Props) => {
	const t = useTranslations(`authText.${authType}.socialbtn`)

	return (
		<button
			type="button"
			className={clc(styles.social, styles[social])}
			onClick={() => {
				onClick(social, authType)
			}}
		>
			<div className={styles.wrap}>
				<div className={styles.icon}>
					{social === 'Apple' && <Image alt="Apple" src="/icon/svgs/Apple.svg" fill></Image>}
					{social === 'Google' && <Image alt="Google" src="/icon/svgs/Google.svg" fill></Image>}
				</div>
				{/* <span className={styles.text}>{t(`${social}`)}</span> */}
			</div>
		</button>
	)
}

export default SocialBtn
